import { Template, TemplateNormalized } from 'lib-shared-legacy-types';

export function normalizeTemplate(template: Template): TemplateNormalized {
  return {
    ...template,
    translations: Object.keys(template.translations || {}).reduce(
      (tr, locale) => ({
        ...tr,
        [locale]: {
          ...template.translations[locale],
          isEnabled: !template.translations[locale].is_deactivated,
        },
      }),
      {},
    ),
  };
}
